export default __webpack_public_path__ + "static/media/discount-tag-tick.3872fc79.svg";